import * as actionTypes from './actionTypes';
import { WhatsAppReceived } from './types';

/*------------------------------------------------------------------------------------------------*/
/* WhatsApp Messages Fetch Actions                                                                        */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchWhatsAppMessagesRequest
 * Fetch WhatsApp messages request action.
 */
export const fetchWhatsAppMessagesRequest = () => ({
  type: actionTypes.FETCH_WHATSAPP_MESSAGES_REQUEST,
});

/**
 * fetchWhatsAppMessagesResponse
 * Fetch WhatsApp messages response action.
 */
export const fetchWhatsAppMessagesResponse = (response: WhatsAppReceived[]) => ({
  type: actionTypes.FETCH_WHATSAPP_MESSAGES_RESPONSE,
  response,
});
